export default __webpack_public_path__ + "static/Epilogue-Regular-10c41766bc24462ff98e20fe64afb672.ttf";